const appleAuth = {};
const appleAuthAndroid = {};
export { appleAuth, appleAuthAndroid };
